import { siteTitle } from './components/podcast/constants'

export function addSuffix(title: string) {
  return `${title} – ${siteTitle}`
}
